/**
* Time dropdown validation
*/

const orderTime = () => {
  const inputField:any = document.querySelector('[name="time"]');
  const submitBtn = document.querySelector('.js-order-submit-btn')
  const error = document.querySelector(".time-error");

  if (!inputField || !error || !submitBtn) return;

  submitBtn.addEventListener("click", (e) => {
    var val = inputField.options[inputField.selectedIndex].value;
    if(val == 0) {
      error.classList.add("show");
      error.innerHTML = "有効な日付を選択してください。";
    }
  })

  inputField.addEventListener("change", () => {
    error.classList.remove("show");
    error.innerHTML = "";
  })
}

export default orderTime
